<!--
    @修改人：黎柏祺
    @修改时间：2018-12-14
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: libaiqi
    @创建时间: 2018-10-19
    @版本:v1.0.24
    @描述: 安全设置
    -->
<template>
  <div class="securityRole__content">
    <div class="securityRole__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('securityRole.name')">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('securityRole@search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_create">{{ $t('securityRole.create') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false" :title="$t('securityRole.addNewRole')" :visible.sync="dialogVisible" width="600px">
      <el-form :model="userForm" label-position="right" label-width="40px" ref="userForm" :inline="true">
        <el-form-item :label="$t('securityRole.name')" >
          <span><el-input v-model="userForm.name"></el-input></span>
        </el-form-item>
        <el-form-item>      
          <span><el-button type="primary" @click="e_uerSearch" v-g-rac="gRac('roleManage_search')">{{$t('common.search')}}</el-button></span>
        </el-form-item>
        <el-form-item input-width="550px">
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
              prop="name"
              :label="$t('securityRole.table.name')">
            </el-table-column>
            <el-table-column
              prop="description"
              :label="$t('securityRole.table.description')">
            </el-table-column>
            <el-table-column
              prop="creator"
              :label="$t('securityRole.table.creator')">
            </el-table-column>
            <el-table-column
              :label="$t('common.handle')"
              >
              <template slot-scope="scope">
                  <el-button type="text" size="small" @click="e_addUser(scope.row)" >{{ $t('securityRole.add') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item input-width="550px">
          <div class="user-wrap" v-show="selectUsers.length > 0">
            <div class="each-machine" v-for="(item, index) in selectUsers" :key="index" :title="item.name">
              <i class="icon iconfont icon-amc_circle_close icon-delete" @click="deleteUser(index)"></i>
              <span v-text="item.name"></span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="e_isconfirmAddUser" v-g-rac="gRac('securityRole@save')">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
<script >
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import securityRoleBiz from '@/logic/systemSetting/securityRoleBiz'
  import roleManageBiz from '@/logic/systemSetting/roleManageBiz'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, dic, table],
    data () {
      const that = this
      return {
        form: {
          name: ''
        },
        userForm: {
          name: ''
        },
        tableData: [],
        dialogVisible: false,
        selectUsers: [],
        tableControl: [
          {
            label: that.$t('common.delete'),
            callback: that.e_delete,
            rac: () => that.gRac('securityRole@delete')
          }
        ]
      }
    },
    methods: {
      initTable () {
        this.tInitTable({
          lanKey: 'securityRole.table',
          head: ['name', 'description', 'creator', 'createTime'],
          requestFun: this.search,
          headOpt: {}
        })
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        securityRoleBiz.findByPage(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map((item) => {
              item.createTime = TimeFormat.getFormatTime(item.createTime)
            })
          }
          this.tData = data
        }).catch((err) => {
          console.error(err)
        })
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      e_uerSearch () {
        const reqData = extend(true, { perPageCount: 500 }, this.userForm)
        roleManageBiz.findAll(reqData).then((data) => {
          this.tableData = data.dataList
        }).catch((err) => {
          console.error(err)
        })
      },
      deleteUser (i) {
        this.selectUsers.splice(i, 1)
        this.selectIds.splice(i, 1)
      },
      e_create () {
        this.e_uerSearch()
        this.dialogVisible = true
      },
      e_delete (rowData) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          securityRoleBiz.deleteRole({
            id: rowData.id
          }).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {

        })
      },
      e_addUser (rowData) {
        if (!this.selectUsers.some(item => item.id === rowData.id)) {
          this.selectUsers.push(rowData)
        }
      },
      e_isconfirmAddUser () {
        if (this.selectUsers.length < 1) {
          this.$message({
            message: this.$t('securityRole.noChoice'),
            type: 'warning'
          })
          return
        }
        let idArr = []
        this.selectUsers.map(item => { idArr.push(item.id) })
        securityRoleBiz.addRole({ids: idArr}).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.selectUsers = []
          this.dialogVisible = false
          setTimeout(() => {
            this.e_search()
          }, 600)
        })
      },
      resetForm () {
        this.selectUsers = []
        this.dialogVisible = false
      }
    },
    mounted () {
      this.initTable()
      this.search()
    }
  }
</script>
<style scoped>
  .securityRole__content .user-wrap {
    border: 1px solid #ddd;
    width: 100%;
  }
  .securityRole__content .each-machine {
    width: 135px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .securityRole__content .each-machine:hover {
    background: #eaeaea;
    border: 1px solid #ddd;
  }
  .securityRole__content .each-machine:hover .icon-delete {
    display: block;
  }
  .securityRole__content .icon-delete {
    display: none;
    color: #a0a0a0;
    font-size: 18px;
    position: absolute;
    bottom: 16px;
    right: -8px;
  }
  .securityRole__content .icon-delete:hover {
    color: #3385ff;
  }
</style>
    